<input id="slider-retorno" type="text" data-provide="slider" ticks_tooltip="true" />